export const VALIDATION_TYPES = {
  // Zod validator types for common field formats with direct compatibility
  // with @sword-health/input-validation for validations and translations
  emailFormat: 'emailFormat',
  internationalPhoneFormat: 'internationalPhoneFormat',
  invalidCharacter: 'invalidCharacter',
  maxFileSize: 'maxFileSize',
  isNotFuture: 'isNotFuture',
  maxLength: 'maxLength',
  maxValue: 'maxValue',
  minLength: 'minLength',
  required: 'required',
  telephone: 'internationalPhoneFormat',
  url: 'validUrl',
  username: 'usernameFormat',
  generic: 'generic',
  // Zod validator types for custom validation
  custom: {
    daysOnHold: 'daysOnHold',
    invalidEmailOrUsername: 'invalidEmailOrUsername',
    passwordMatch: 'passwordMatch',
    url: 'url',
    card: {
      alreadyHasCard: 'alreadyHasCard',
      cardAlreadyAssigned: 'cardAlreadyAssigned',
      invalidCard: 'invalidCard',
    },
  },
}
